import { List } from 'immutable';

export const files = state => state.getIn(['files', 'entities']);
export const root = state => state.getIn(['files', 'entities']);

export const fileIdsForStore =
  rootKeyPath =>
    state =>
      state.getIn([...rootKeyPath, 'fileIds']);

export const filesForStore =
  rootKeyPath =>
    state => fileIdsForStore(rootKeyPath)(state)
      .reduce((result, fileId) => result.push(files(state).get(String(fileId))), new List());

export const isLoadingForStore =
  rootKeyPath =>
    state => state.getIn([...rootKeyPath, 'isLoading']);

export const withFiles =
  rootKeyPath =>
    state => ({
      files: filesForStore(rootKeyPath)(state),
      isLoading: isLoadingForStore(rootKeyPath)(state),
    });

export const fileById = (state, id) => root(state).get(String(id));
export const filesByIds = (state, ids) => ids.map(id => fileById(state, id));
